import { BACKEND_URL_PREFIX } from '../utils/const';
import { buildDefaultHeaders } from './helper';
import {
  NEW_BOOK_ORDERS_REQUEST, NEW_BOOK_ORDERS_REQUEST_COMPLETED, NEW_BOOK_ORDERS_REQUEST_FAILED,
  NEW_BOOK_ORDERS_ID_REQUEST, NEW_BOOK_ORDERS_ID_REQUEST_COMPLETED, NEW_BOOK_ORDERS_ID_REQUEST_FAILED,
  NEW_BOOK_ORDER_CREATE_COMPLETED
} from './types';

export const newBookRequestList = dates =>
  async (dispatch, getState) => {
    dispatch({ type: NEW_BOOK_ORDERS_REQUEST });
    let datesString = '';
    if (dates) {
      datesString = `?from=${dates[0]}&to=${dates[1]}`;
    }
    const url = `${BACKEND_URL_PREFIX}/library/newbookrequest${datesString}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: NEW_BOOK_ORDERS_REQUEST_COMPLETED, data: result });
    } else {
      dispatch({ type: NEW_BOOK_ORDERS_REQUEST_FAILED, data: response });
    }
  }

export const newBookRequestId = requestId =>
  async (dispatch, getState) => {
    dispatch({ type: NEW_BOOK_ORDERS_ID_REQUEST });
    const url = `${BACKEND_URL_PREFIX}/library/newbookrequest/${requestId}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: NEW_BOOK_ORDERS_ID_REQUEST_COMPLETED, data: result });
    } else {
      dispatch({ type: NEW_BOOK_ORDERS_ID_REQUEST_FAILED, data: response });
    }
  }

export const addBookRequest = values =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/newbookrequest`;
    const response = await fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify(values),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: NEW_BOOK_ORDER_CREATE_COMPLETED, data: result });
      dispatch(newBookRequestList());
    }
  }

export const deleteBookRequest = requestId =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/newbookrequest/${requestId}`;
    const response = await fetch(`${url}`, {
      method: 'DELETE',
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      dispatch(newBookRequestList());
    } else {
      throw new Error('Cannot delete');
    }
  }

export const addNewBookToOrder = (values, requestId) =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/newbookrequestbook/${requestId}`;
    const response = await fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify(values),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      dispatch(newBookRequestId(requestId));
    } else {
      throw new Error('Unknown params');
    }
  }

export const editNewBook = (values, bookId, parentId) =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/newbookrequestbook/${bookId}`;
    const response = await fetch(`${url}`, {
      method: 'PUT',
      body: JSON.stringify(values),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      dispatch(newBookRequestId(parentId));
    } else {
      throw new Error('Can not edit');
    }
  }

export const deleteNewBook = (bookId, parentId) =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/newbookrequestbook/${bookId}`;
    const response = await fetch(`${url}`, {
      method: 'DELETE',
      body: {},
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      dispatch(newBookRequestId(parentId));
    } else {
      throw new Error('Can not delete');
    }
  }
